import { ILastWebsocketJsonMessage } from '../../../../interfaces/webSocketConnectionInfo';

export interface IDashboardContentView {
  openBrowserUrlDialog: boolean;
  onSubmitBrowserUrl: (url: string) => void;
  onCloseBrowserUrlDialog: () => void;
}

export type ParticipantPosition = {
  timestamp: number;
  x: number;
  y: number;
  z: number;
  r: number;
};

export enum PoiMediaType {
  VIDEO = 'video',
  WEBSITE = 'websiteUrl',
  AUDIO = 'audio',
  IMAGE = 'image',
  FILE = 'file',
  THREE_D_OBJECT_VIEW = '3dObjectView',
  THREE_D_PROP = '3dProp',
  WEB_BROWSER = 'WEB_BROWSER',
}

export type SendToBriefcasePropsType = Pick<
  ILastWebsocketJsonMessage,
  'fileName' | 'downloadUrl'
>;

export interface SendToBriefcasePropsTypeFull extends SendToBriefcasePropsType {
  mediaType?: PoiMediaType;
}

export type StartStreamVideoRequestType = Pick<
  ILastWebsocketJsonMessage,
  'roomId' | 'region' | 'screenName'
>;

export interface IGenerateZoomTokenProps {
  role: number;
  sessionName: string;
  expirationSeconds: number;
  userIdentity?: string;
  sessionKey?: string;
  geoRegions?: string[];
  cloudRecordingOption?: number;
  cloudRecordingElection?: number;
  audioCompatibleMode?: number;
}
